// extracted by mini-css-extract-plugin
module.exports = {"settingsSectionTitle":"SettingsSectionTitle_settingsSectionTitle__zXDQ-","goBack":"SettingsSectionTitle_goBack__TkpFX"};